import { useState, useEffect } from 'react'
import { useAppSelector, useAppDispatch } from '../../../redux/types/types'
import { getPlaces } from '../../../redux/actions/placesAction'
import { useToast } from '../../../context/ToastContext'

export const usePlatforms = (claimData: any) => {
  const { token } = useAppSelector((state) => state.auth)
  const { places } = useAppSelector((state) => state.places)
  const dispatch = useAppDispatch()
  const { showError } = useToast()

  const [platformNames, setPlatformNames] = useState<{ id: number; name: string }[]>([])
  const [platformId, setPlatformId] = useState<number>(claimData?.place?.id || -1)
  const [platformSize, setPlatformSize] = useState<number | number[]>(-1)

  useEffect(() => {
    const updatedPlatforms =
      places?.places?.map((item: any) => ({
        id: item.id,
        name: item.name,
      })) || []
    setPlatformNames(updatedPlatforms)
  }, [places?.places])

  useEffect(() => {
    if (claimData?.place?.id) {
      setPlatformId(claimData.place.id)
      const foundItem = places.places.find((item) => item.id === claimData.place.id)
      if (foundItem) {
        setPlatformSize(foundItem?.size)
      }
    }
  }, [claimData?.place?.id, places.places])

  useEffect(() => {
    const fetchPlaces = async () => {
      if (token && (!places?.places || places.places.length === 0)) {
        const resultAction = await dispatch(
          getPlaces({
            token,
            page: 1,
            itemsPerPage: 1000,
          }),
        )

        if (getPlaces.rejected.match(resultAction)) {
          const errorMessage = resultAction.payload
          if (errorMessage === 'Unauthorized') {
            showError('Ошибка авторизации')
          } else {
            showError('Ошибка при загрузке платформ')
          }
        }
      }
    }

    fetchPlaces()
  }, [token, dispatch])

  return {
    platformNames,
    platformId,
    platformSize,
    setPlatformId,
    setPlatformSize,
    places: places?.places || [],
  }
}
